import { FC } from 'react';
import { Chip } from '../Chips/Chip';
import { ChipProps as MuiChipProps } from '@mui/material/Chip';

export type FilterChipProps = {
  text: string;
  onClose: () => void;
  color?: MuiChipProps['color'];
  size?: MuiChipProps['size'];
  variant?: MuiChipProps['variant'];
  label?: string;
  onDelete?: MuiChipProps['onDelete'];
  icon?: MuiChipProps['icon'];
  isLoading?: boolean;
};

export const FilterChip: FC<FilterChipProps> = ({
  text,
  onClose,
  variant = 'filled',
  ...props
}) => {
  return <Chip {...props} label={text} onDelete={onClose} variant={variant} />;
};
